import { IonPage, IonToolbar, IonButtons, IonButton, IonIcon, IonContent } from '@ionic/react'
import { arrowBack } from 'ionicons/icons'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import claroLogo from '../../../assets/images/claro.png'
import Signature from '../../../components/Signature/Signature'
import { useStepsContext } from '../../../context/StepsContext'
import { useAppContext } from '../../../context/AppContext'
import useMessages from '../../../hooks/useMessages'
import { procedureComplete } from '../../../redux/actions'
import LineValidation from './LineValidation'
import IdValidation from './IdValidation'
import DataConfirmation from './DataConfirmation'
import NominativityFailed from './NominativityFailed'
import NominativitySuccess from './NominativitySuccess'

const NewNominativity = () => {
  const totalSteps: number = 4
  const history = useHistory()
  const dispatch = useDispatch()
  const { modalMessage } = useMessages()

  const { setBlockNavigation }: any = useAppContext()
  const { newProcedureStep, dataStep, success, resetSteps }: any = useStepsContext()

  useEffect(() => {
    if (!location.hash.includes('noback')) {
      window.location.hash = '#noback'
    }
  }, [location.hash])

  const leaveNewNominativity = () => {
    dispatch(procedureComplete())
    resetSteps()
    history.push('/procedures/nominatividad')
    setBlockNavigation(false)
  }

  // Navegación hacia atrás de las pantallas del proceso de Nueva Nominatividad
  const goBack: any = () => {
    if (newProcedureStep > 1 && newProcedureStep < 4)
      return modalMessage(
        '¡Venís bien!',
        'Estás validando la identidad del cliente. Si abandonás el proceso ahora, deberás empezarlo nuevamente.',
        leaveNewNominativity,
        'CONTINUAR VALIDACIÓN'
      )
    if (newProcedureStep === 4)
      return modalMessage(
        '¡Venís bien!',
        'Estás por finalizar el proceso. Si abandonás ahora, el trámite quedará sin completarse.',
        leaveNewNominativity,
        'CONTINUAR TRÁMITE'
      )

    leaveNewNominativity()
  }

  return (
    <IonPage>
      <header id="procedure-toolbar">
        <IonToolbar>
          <IonButtons slot="start" hidden={(newProcedureStep === 3 && dataStep === 2) || newProcedureStep === 5}>
            <IonButton onClick={goBack}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <img
            src={claroLogo}
            alt="back page button"
            className={`max-height-22 ${
              ((dataStep === 2 && newProcedureStep === 3) || newProcedureStep === 5) && 'ion-padding-start'
            }`}
          />
        </IonToolbar>
        {newProcedureStep < 5 && (
          <span className="activacion-steps">
            Paso {newProcedureStep} de {totalSteps}
          </span>
        )}
      </header>
      <IonContent style={{ overflowY: 'auto', overflowX: 'hidden' }}>
        {newProcedureStep === 1 && <LineValidation />}
        {newProcedureStep === 2 && <IdValidation />}
        {newProcedureStep === 3 && <DataConfirmation />}
        {newProcedureStep === 4 && <Signature procedure="nominativity" />}
        {newProcedureStep === 5 && success && <NominativitySuccess />}
        {newProcedureStep === 5 && !success && <NominativityFailed />}
      </IonContent>
    </IonPage>
  )
}

export default NewNominativity
